import { Grid, TextField } from '@mui/material';

type SignatureExtraFieldsProps = {
    clarificationName: string;
    dniName: string;
    roleName: string;
    values: Record<string, string>;
    disabled: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    clarificationError?: boolean;
    dniError?: boolean;
    roleError?: boolean;
};

const SignatureExtraFields = ({
    clarificationName,
    dniName,
    roleName,
    values,
    disabled,
    onChange,
    clarificationError = false,
    dniError = false,
    roleError = false
}: SignatureExtraFieldsProps) => {
    return (
        <Grid container spacing={1} mt={1}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Aclaración"
                    name={clarificationName}
                    value={values[clarificationName] ?? ''}
                    onChange={onChange}
                    disabled={disabled}
                    error={clarificationError}
                />
            </Grid>

            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="DNI"
                    name={dniName}
                    value={values[dniName] ?? ''}
                    onChange={(event: any) => {
                        const rawValue = event.target.value;

                        if (/^\d{0,8}$/.test(rawValue)) {
                            onChange(event);
                        }
                    }}
                    inputProps={{
                        maxLength: 8,
                        inputMode: 'numeric',
                        pattern: '[0-9]*'
                    }}
                    disabled={disabled}
                    error={dniError}
                />
            </Grid>

            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Cargo"
                    name={roleName}
                    value={values[roleName] ?? ''}
                    onChange={onChange}
                    disabled={disabled}
                    error={roleError}
                />
            </Grid>
        </Grid>
    );
};

export default SignatureExtraFields;
